import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";

import tooltipsStyle from "assets/jss/material-kit-pro-react/tooltipsStyle.jsx";

const styles = theme => ({
    ...tooltipsStyle,
    lightToolTip: {
        background: theme.palette.common.white,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[1],
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
    },
})

class FacetChip extends React.Component {
    render() {
        const { props, classes } = this.props,
            { google_info, onClick, onRemove, isSelected, className, classNameRemove, facet, tag, key, getTagDisplayValue } = props,
            rightPadding = isSelected ? '14px' : 0,
            split = getTagDisplayValue(tag).split('||'),
            text = split.length > 1 ? split[0].split('|')[0] : '',
            number = split.length > 1 ? split[1] : '';


        let title = '';

        if (google_info && google_info.description)
            title = google_info.description

        let chip =
            <a key={key} onClick={e => { onClick(e, facet, tag) }} className={"react-tagsinput-tag " + (isSelected ? "success " : "info ") + className} style={{ 'paddingRight': rightPadding }}>
                <span style={{ 'paddingRight': 0 }} >{text}
                    <span className={"react-tagsinput-tag " + (isSelected ? "success" : "info")} style={{ 'marginTop': 0, 'marginBottom': 0, 'paddingRight': '8px' }}>
                        {number}
                    </span>
                    {isSelected ? <a className={{ classNameRemove }} onClick={onRemove} style={{ 'paddingRight': 8, opacity: 1 }} /> : null}
                </span>
            </a>
        if (google_info)
            chip = <Tooltip classes={{ tooltip: classes.tooltip + ' ' + classes.lightToolTip }} leaveDelay={5}
                title={
                    <React.Fragment>
                        {google_info && google_info.image ? <img src={google_info.image} style={{ width: '100%' }} alt={text} /> : null}
                        {title}
                    </React.Fragment>
                } placement="right" >
                {chip}
            </Tooltip>
        return chip

    }
}

FacetChip.propTypes = {
    classes: PropTypes.object,
    props: PropTypes.object
}

export default withStyles(styles)(FacetChip);



// WEBPACK FOOTER //
// ./src/components/Article/common/FacetChip.jsx